import { render, staticRenderFns } from "./BaseFieldService.vue?vue&type=template&id=379e39a1&scoped=true"
import script from "./BaseFieldService.vue?vue&type=script&lang=js"
export * from "./BaseFieldService.vue?vue&type=script&lang=js"
import style0 from "./BaseFieldService.vue?vue&type=style&index=0&id=379e39a1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379e39a1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VIcon,VImg,VTextField,VTextarea})
